export const TERMINAL_FORM = {
  terminalForm: document.querySelector('#aafp_add-terminal-form') as HTMLFormElement,
  terminalFormUpdate: document.querySelector('#aafp_update-terminal-form') as HTMLFormElement,
  terminalName: document.querySelector('#aafp_form-terminal-name') as HTMLInputElement,
  terminalPartnerSelect: document.querySelector('#aafp_dropdown-button-partner') as HTMLElement,
  terminalPartner: document.querySelector('#aafp_form-terminal-partner-number') as HTMLInputElement,
  terminalLastHeartbeat: document.querySelector('#aafp_form-terminal-last-heartbeat') as HTMLInputElement,
  terminalLastTransaction: document.querySelector('#aafp_form-terminal-last-transaction') as HTMLInputElement,
  terminalDescription: document.querySelector('#aafp_form-terminal-description') as HTMLInputElement,
  terminalFilterButton: document.querySelector('.aafp_dropdown-button') as HTMLElement,
  terminalCostCents: document.querySelector('#aafp_form-terminal-cost-cents') as HTMLInputElement,
  terminalMarginCents: document.querySelector('#aafp_form-terminal-margin-cents') as HTMLInputElement,
  terminalDefaultPricing: document.querySelector('#aafp_form-terminal-default-pricing') as HTMLInputElement,
  terminalGallonLimit: document.querySelector('#aafp_form-terminal-gallon-limit') as HTMLInputElement,
  terminalBillingType: document.querySelector('#aafp_dropdown-button-one') as HTMLElement,
  terminalTransactionFee: document.querySelector('#aafp_form-terminal-transaction-fee') as HTMLInputElement,
  terminalFee: document.querySelector('#aafp_form-terminal-fee') as HTMLInputElement,
  terminalStatus: document.querySelector('#aafp_dropdown-button-two') as HTMLElement,
  terminalPublic: document.querySelector('#aafp_dropdown-button-public') as HTMLElement,
  terminalNational: document.querySelector('#aafp_terminal-national') as HTMLInputElement,
  terminalOutOfService: document.querySelector('#aafp_terminal-out-of-service') as HTMLInputElement,
  terminalAddressOne: document.querySelector('#aafp_form-terminal-address-one') as HTMLInputElement,
  terminalAddressTwo: document.querySelector('#aafp_form-terminal-address-two') as HTMLInputElement,
  terminalAddressCity: document.querySelector('#aafp_form-terminal-address-city') as HTMLInputElement,
  terminalAddressState: document.querySelector('#aafp_dropdown-button-state') as HTMLElement,
  terminalAddressZip: document.querySelector('#aafp_form-terminal-address-zip') as HTMLInputElement,
  terminalSubmitButton: document.querySelector('#aafp_terminal-submit') as HTMLElement,
  terminalRegion: document.querySelector('#aafp_form-terminal-region') as HTMLInputElement,
  terminalSvcBranch: document.querySelector('#aafp_form-terminal-branch') as HTMLInputElement,
  terminalCustList: document.querySelector('#aafp_form-terminal-customer') as HTMLInputElement,
  terminalContactName: document.querySelector('#aafp_form-terminal-contact-name') as HTMLInputElement,
  terminalContactPhone: document.querySelector('#aafp_form-terminal-contact-phone') as HTMLInputElement,
  terminalContactEmail: document.querySelector('#aafp_form-terminal-contact-email') as HTMLInputElement,
  terminalContactNameTwo: document.querySelector('#aafp_form-terminal-contact-name-two') as HTMLInputElement,
  terminalContactPhoneTwo: document.querySelector('#aafp_form-terminal-contact-phone-two') as HTMLInputElement,
  terminalContactEmailTwo: document.querySelector('#aafp_form-terminal-contact-email-two') as HTMLInputElement,
  terminalContactNameThree: document.querySelector('#aafp_form-terminal-contact-name-three') as HTMLInputElement,
  terminalContactPhoneThree: document.querySelector('#aafp_form-terminal-contact-phone-three') as HTMLInputElement,
  terminalContactEmailThree: document.querySelector('#aafp_form-terminal-contact-email-three') as HTMLInputElement,
  terminalNotes: document.querySelector('#aafp_form-terminal-notes') as HTMLInputElement,
  terminalAccessDesc: document.querySelector('#aafp_form-terminal-access-description') as HTMLInputElement,
  terminalSerialNum: document.querySelector('#aafp_form-terminal-serial-number') as HTMLInputElement,
  terminalIpAddress: document.querySelector('#aafp_form-terminal-ip-address') as HTMLInputElement,
  terminalOrderedDate: document.querySelector('#aafp_form-terminal-ordered-date') as HTMLInputElement,
  terminalMonitorSerialNumber: document.querySelector('#aafp_form-terminal-monitor-serial-number') as HTMLInputElement,
  terminalGPSLatitude: document.querySelector('#aafp_form-terminal-gps-latitude') as HTMLInputElement,
  terminalGPSLongitude: document.querySelector('#aafp_form-terminal-gps-longitude') as HTMLInputElement,
  terminalInternalNotes: document.querySelector('#aafp_form-terminal-internal-notes') as HTMLInputElement
}

export const BILLING_TYPE = [
  { id: 'T', name: 'Transaction Billing' },
  { id: 'B', name: 'Bulk Billing' }
];

export const TERMINAL_STATUS = [
  { id: '1', name: 'Active' },
  { id: '0', name: 'Inactive' }
];

export const TERMINAL_PUBLIC = [
  { id: 'Public', name: 'Public' },
  { id: 'Private', name: 'Private' }
];

export const STATE_ABBR = [
  { id: 'AL', name: 'Alabama'},
  { id: 'AK', name: 'Alaska'},
  { id: 'AZ', name: 'Arizona'},
  { id: 'AR', name: 'Arkansas'},
  { id: 'CA', name: 'California'},
  { id: 'CO', name: 'Colorado'},
  { id: 'CT', name: 'Connecticut'},
  { id: 'DE', name: 'Delaware'},
  { id: 'DC', name: 'District Of Columbia'},
  { id: 'FL', name: 'Florida'},
  { id: 'GA', name: 'Georgia'},
  { id: 'HI', name: 'Hawaii'},
  { id: 'ID', name: 'Idaho'},
  { id: 'IL', name: 'Illinois'},
  { id: 'IN', name: 'Indiana'},
  { id: 'IA', name: 'Iowa'},
  { id: 'KS', name: 'Kansas'},
  { id: 'KY', name: 'Kentucky'},
  { id: 'LA', name: 'Louisiana'},
  { id: 'ME', name: 'Maine'},
  { id: 'MD', name: 'Maryland'},
  { id: 'MA', name: 'Massachusetts'},
  { id: 'MI', name: 'Michigan'},
  { id: 'MN', name: 'Minnesota'},
  { id: 'MS', name: 'Mississippi'},
  { id: 'MO', name: 'Missouri'},
  { id: 'MT', name: 'Montana'},
  { id: 'NE', name: 'Nebraska'},
  { id: 'NV', name: 'Nevada'},
  { id: 'NH', name: 'New Hampshire'},
  { id: 'NJ', name: 'New Jersey'},
  { id: 'NM', name: 'New Mexico'},
  { id: 'NY', name: 'New York'},
  { id: 'NC', name: 'North Carolina'},
  { id: 'ND', name: 'North Dakota'},
  { id: 'OH', name: 'Ohio'},
  { id: 'OK', name: 'Oklahoma'},
  { id: 'OR', name: 'Oregon'},
  { id: 'PA', name: 'Pennsylvania'},
  { id: 'RI', name: 'Rhode Island'},
  { id: 'SC', name: 'South Carolina'},
  { id: 'SD', name: 'South Dakota'},
  { id: 'TN', name: 'Tennessee'},
  { id: 'TX', name: 'Texas'},
  { id: 'UT', name: 'Utah'},
  { id: 'VT', name: 'Vermont'},
  { id: 'VA', name: 'Virginia'},
  { id: 'WA', name: 'Washington'},
  { id: 'WV', name: 'West Virginia'},
  { id: 'WI', name: 'Wisconsin'},
  { id: 'WY', name: 'Wyoming'}
]